import { useContext } from "react";
import { Grid } from "@mui/material";
import { Outlet, useNavigate, useParams } from "react-router-dom";
import { UserContext } from "src/Utils/Context/UserContext";
import { RestaurantContext } from "src/Utils/Context/RestaurantContext";
import { useRestaurantReadAccess } from "src/data/restaurant/queries/restaurant";
import { CircularLoader } from "src/design/CircularLoader";

export const RestaurantAccessBoundary = () => {
  const { user, isLoading: userLoading } = useContext(UserContext);
  const { restaurants, isLoading: restaurantsLoading } =
    useContext(RestaurantContext);
  const { restaurantId } = useParams<{ restaurantId: string }>();
  const navigate = useNavigate();

  const isAdmin = !!user?.admin;

  const {
    data: hasAccess,
    isLoading: accessLoading,
    isError,
  } = useRestaurantReadAccess(restaurantId, !isAdmin && !userLoading);

  const isLoading =
    userLoading || restaurantsLoading || (!isAdmin && accessLoading);

  if (isLoading) {
    return (
      <Grid container justifyContent="center" sx={{ mt: 3 }}>
        <Grid item>
          <CircularLoader />
        </Grid>
      </Grid>
    );
  }

  if (!isAdmin && (hasAccess === false || isError)) {
    const fallback = restaurants[0]
      ? `/restaurant/${restaurants[0].id}`
      : "/restaurant/no-restaurant";
    navigate(fallback, { replace: true });
    return null;
  }

  return <Outlet />;
};
